export const OfflineFallbackNotice = ({ message, testId }) => {
  if (!message) {
    return null;
  }

  return (
    <section className="rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid={testId}>
      {message}
    </section>
  );
};